import { Installation } from 'src/Libs/installations/models'
import { hasAccessToDirectMarketing } from '../../utils'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { LuoxDynamicTariffSoftwareSupport } from '../../config'
import { isSoftwareVersionSupported, useSoftwareVersion } from 'src/Libs/home-power-station'
import { UserData } from '@e3dc-react/shell/Types'

/**
 * This hook returns if the luox extension for dynamic tariffs is accessible
 */
const useAccessLuoxDynamicTariff = (installation?: Installation, userData?: UserData): boolean => {
  const {
    featureFlags: { isLuoxDynamicEnergyTariffEnabled },
  } = useFeatureFlagsContext()

  const { softwareVersion } = useSoftwareVersion()

  if (!isLuoxDynamicEnergyTariffEnabled) return false

  if (
    !softwareVersion ||
    !isSoftwareVersionSupported(`${LuoxDynamicTariffSoftwareSupport.Year}.${LuoxDynamicTariffSoftwareSupport.MonthPatch}`, softwareVersion)
  ) {
    return false
  }

  if (!hasAccessToDirectMarketing(installation, userData)) return false

  return true
}

export default useAccessLuoxDynamicTariff
